export const ADD_NAV = 'ADD_NAV';

export const REMOVE_NAV = 'REMOVE_NAV';
